import { create } from 'zustand';
export var useUserInfoStore = create(function (set) { return ({
    userInfo: {},
    setUserInfo: function (userInfo) { return set(function () { return ({ userInfo: userInfo }); }); },
}); });
